export class TracingPlanTaskObservation {
    tracingTaskObservationId: number = 0;
    tracingTaskId: number = 0;
    description: string = ''; 
    createDate: Date = null;
    
    constructor() {        
    }
}
